import { render, staticRenderFns } from "./CertifiedDoctorsComponent.vue?vue&type=template&id=aa569506&scoped=true"
import script from "./CertifiedDoctorsComponent.vue?vue&type=script&lang=js"
export * from "./CertifiedDoctorsComponent.vue?vue&type=script&lang=js"
import style0 from "./CertifiedDoctorsComponent.vue?vue&type=style&index=0&id=aa569506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa569506",
  null
  
)

export default component.exports